import { useEffect, useState } from 'react';
import { ClientStatus } from '../../../model/types/ClientStatus';
import { useClient } from '../../../context/ClientStatusContext';
import { fetchPrispevokVestnikaInfoList } from '../../../client/prispevokVestnikaInfoListClient';
import PrispevokVestnikaInfo from '../../../model/PrispevokVestnikaInfo';
import Organizacia from '../../../model/ciselniky/Organizacia';

interface ReturnType {
  prispevokVestnikaInfoList: PrispevokVestnikaInfo[];
  prispevokVestnikaInfoListStatus: ClientStatus;
}

export default (
  vestnik: Organizacia,
  hladanyNazov: string,
  limit: number,
): ReturnType => {
  const [, setAction] = useState(0);
  const {
    wrapClient,
    status,
    data,
  } = useClient(fetchPrispevokVestnikaInfoList);

  useEffect(() => {
    setAction(prevState => {
      clearTimeout(prevState);
      return prevState;
    });

    const act = setTimeout(async () => {
      await wrapClient(vestnik, hladanyNazov, limit);
    }, 300);

    // @ts-ignore
    setAction(act);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [hladanyNazov, limit]);
  return <ReturnType>{
    prispevokVestnikaInfoList: data || [],
    prispevokVestnikaInfoListStatus: status,
  };
};
